import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "numberOfColumns", "hidden", "block", "row", "stack", "wrap", "noWrap", "rowReverse", "columnReverse", "justifyContent", "alignItems", "negative", "gutterSize", "gutterValue", "xsGutterValue", "smGutterValue", "mdGutterValue", "lgGutterValue"];
import React from 'react';
import PropTypes from 'prop-types';
import { GridRow } from './Row.styles';

var Row = function Row(_ref) {
  var className = _ref.className,
      children = _ref.children,
      numberOfColumns = _ref.numberOfColumns,
      hidden = _ref.hidden,
      block = _ref.block,
      row = _ref.row,
      stack = _ref.stack,
      wrap = _ref.wrap,
      noWrap = _ref.noWrap,
      rowReverse = _ref.rowReverse,
      columnReverse = _ref.columnReverse,
      justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems,
      negative = _ref.negative,
      gutterSize = _ref.gutterSize,
      gutterValue = _ref.gutterValue,
      xsGutterValue = _ref.xsGutterValue,
      smGutterValue = _ref.smGutterValue,
      mdGutterValue = _ref.mdGutterValue,
      lgGutterValue = _ref.lgGutterValue,
      props = _objectWithoutProperties(_ref, _excluded);

  var additionalProps = function additionalProps(childProps) {
    return {
      numberOfColumns: numberOfColumns,
      gutterSize: childProps.gutterSize || gutterSize,
      gutterValue: 'gutterValue' in childProps ? childProps.gutterValue : gutterValue,
      xsGutterValue: 'xsGutterValue' in childProps ? childProps.xsGutterValue : xsGutterValue,
      smGutterValue: 'smGutterValue' in childProps ? childProps.smGutterValue : smGutterValue,
      mdGutterValue: 'mdGutterValue' in childProps ? childProps.mdGutterValue : mdGutterValue,
      lgGutterValue: 'lgGutterValue' in childProps ? childProps.lgGutterValue : lgGutterValue
    };
  };

  var childrenWithprops = React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, additionalProps(child.props));
    }

    return child;
  });
  return /*#__PURE__*/React.createElement(GridRow, _extends({
    className: className,
    numberOfColumns: numberOfColumns,
    hiddenBreakpoint: hidden,
    block: block,
    row: row,
    stack: stack,
    wrap: wrap,
    noWrap: noWrap,
    rowReverse: rowReverse,
    columnReverse: columnReverse,
    justifyContent: justifyContent,
    alignItems: alignItems,
    negative: negative,
    gutterSize: gutterSize,
    gutterValue: gutterValue,
    xsGutterValue: xsGutterValue,
    smGutterValue: smGutterValue,
    mdGutterValue: mdGutterValue,
    lgGutterValue: lgGutterValue
  }, props), childrenWithprops);
};

Row.propTypes = {
  /**
   * Prop for the number of columns the entire Row width is split into
   */
  numberOfColumns: PropTypes.number,

  /**
   * Prop for applying flex row css at a specific breakpoint
   */
  row: PropTypes.string,

  /**
   * Prop for applying flex stack css at a specific breakpoint
   */
  stack: PropTypes.string,

  /**
   * Prop for applying hidden css at a specific breakpoint
   */
  hidden: PropTypes.string,

  /**
   * Prop for applying block css at a specific breakpoint
   */
  block: PropTypes.string,

  /**
   * Prop for applying wrap css at a specific breakpoint
   */
  wrap: PropTypes.string,

  /**
   * Prop for applying nowrap css at a specific breakpoint
   */
  noWrap: PropTypes.string,

  /**
   * Prop for applying row-reverse css at a specific breakpoint
   */
  rowReverse: PropTypes.string,

  /**
   * Prop for applying column-reverse css at a specific breakpoint
   */
  columnReverse: PropTypes.string,

  /**
   * Prop for applying justify-content css at a specific breakpoint
   */
  justifyContent: PropTypes.string,

  /**
   * Prop for applying negative margins to the Row itself at a specific breakpoint
   */
  negative: PropTypes.string,

  /**
   * Prop for applying align-items css at a specific breakpoint
   */
  alignItems: PropTypes.string,

  /**
   * Prop for width of gutters
   */
  gutterSize: PropTypes.string,

  /**
   * Specify the base gutter styling to use for this column. -1 for negative margins,
   * 0 for no margins and 1 for a left-margin. Default is set to 1.
   */
  gutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at xs breakpoint
   */
  xsGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at sm breakpoint
   */
  smGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at md breakpoint
   */
  mdGutterValue: PropTypes.oneOf([-1, 0, 1]),

  /**
   * Optional prop for overriding the base gutterValue at lg breakpoint
   */
  lgGutterValue: PropTypes.oneOf([-1, 0, 1])
};
Row.displayName = 'Row';
Row.defaultProps = {
  numberOfColumns: 12,
  justifyContent: 'start',
  gutterSize: '30px',
  gutterValue: 1
};
export default Row;